import React from 'react'
import {Modal, notification} from 'antd'
import {bulkOnHoldOrderByIdsV2} from "../../../../../services/api/3dApi"

const bulkOnHoldByIds = async (ids) => {
    const payload = {
        ids,
    }

    const {data: response} = await bulkOnHoldOrderByIdsV2(payload)

    const {success, error, data} = response

    if (!success) {
        throw new Error(error)
    }

    return data
}

export default function (ids, onSuccess, onReset) {
    Modal.confirm({
        title: 'Bạn chắc chắn đánh dấu tạm dừng các orders được chọn ?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk() {
            bulkOnHoldByIds(ids).then(result => {
                const {pass, notPass} = result

                if (pass.length > 0) {
                    notification.success({
                        message: 'Đánh dấu tạm dừng thành công ',
                        description: (
                            <>
                                {pass.length} items được đánh dấu tạm dừng thành công
                            </>
                        ),
                    })
                }

                if (notPass.length > 0) {
                    notification.error({
                        message: 'Đánh dấu tạm dừng thất bại ',
                        description: (
                            <>
                                {notPass.length} items không được đánh dấu tạm dừng
                            </>
                        ),
                    })
                }

                onReset()
                onSuccess()
            }).catch(err => {
                notification.error({
                    message: 'ERROR',
                    description: err.message,
                })
            })
        }
    })
}
